import Settings from 'src/Settings';
import ConnectAndPayDescriptor from './recentorder-canteen-descriptor';
import CompanyKitchenDescriptor from './recentorder-companykitchen-descriptor';
import RedesignDescriptor from './recentorder-redesign-descriptor';
import RefiveDescriptor from './recentorder-refive-descriptor';
import AramarkDescriptor from './recentorder-aramark-descriptor';
import {BuildTypeEnum} from 'src/constants/BuildTypeEnum';

const typeDescriber = {
  [BuildTypeEnum.default]: RedesignDescriptor,
  [BuildTypeEnum.canteen]: ConnectAndPayDescriptor,
  [BuildTypeEnum.aramark]: AramarkDescriptor,
  [BuildTypeEnum.companykitchen]: CompanyKitchenDescriptor,
  [BuildTypeEnum.refive]: RefiveDescriptor,
};

export function getRecentOrderDescriber() {
  return typeDescriber[Settings.buildType as keyof typeof typeDescriber];
}
